export default "__VITE_ASSET__BQr1fk2E__"